import React, { useContext, useEffect, useState } from "react";
import { upgradeViaChat } from "../../onboarding/Trial";
import TrialOverImage from "../../upsolver-images/trial-over.svg";
import { Button } from "./Button";
import { GlobalContext } from "../../GlobalContext";
import { setTimeoutVisible } from "../PageVisibilityStore";
import { observer } from "mobx-react-lite";
import { Redirect } from "react-router";
import { organizationExpired } from "../api/contracts/Organization";

export function TrialOverSadRobot() {
  const { auth } = useContext(GlobalContext);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    return setTimeoutVisible(() => {
      auth.refreshTrial();
      setRefresh((x) => !refresh);
    }, 5000);
  }, [refresh]);

  return (
    <div className="big-content trial-over">
      <img src={TrialOverImage} alt="Your trial period has ended." />
      <h1>Your Trial Period has Expired.</h1>
      <Button type="primary" title="Contact Us" onClick={upgradeViaChat} />
    </div>
  );
}

export const TrialOverSadRobotPage = observer(() => {
  const { auth } = useContext(GlobalContext);
  return organizationExpired(auth.currentOrganization) ? (
    <Redirect to="/inputs/list" />
  ) : (
    <div className="container">
      <div className="content center-action no-local-api">
        <TrialOverSadRobot />
      </div>
    </div>
  );
});
